// routes/guards/authLoaders.js
import { redirect } from "react-router-dom";
import api from "@/utils/axios";

const API_ME = "/v1/auth/me";
const API_REFRESH = "/v1/auth/refresh";

export const roleGuard =
  (allowed = []) =>
  async () => {
    // Normalize roles (case-insensitive)
    const allowedSet = new Set(allowed.map((r) => String(r).toLowerCase()));

    // 1) Load current access token (if you store it)
    let at = localStorage.getItem("cm_at") || "";

    // Helper to fetch /me with a token (returns user or throws)
    const fetchMe = async (token) => {
      const { data } = await api.get(API_ME, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        withCredentials: true, // safe; doesn’t hurt if you use httpOnly refresh
      });
      return data?.user;
    };

    try {
      let user = null;

      // 2) Try /me with existing token (if we have one)
      if (at) {
        try {
          user = await fetchMe(at);
        } catch {
          // fall through to refresh attempt
        }
      }

      // 3) No user yet? Try refresh to mint a new access token
      if (!user) {
        const r = await api.post(API_REFRESH, null, { withCredentials: true });
        const newAt = r?.data?.accessToken || "";
        if (!newAt) throw new Error("No access token after refresh");

        // persist and retry /me
        localStorage.setItem("cm_at", newAt);
        at = newAt;
        user = await fetchMe(at);
      }

      if (!user) throw new Error("No user payload");

      // 4) Role gate (empty 'allowed' means any logged-in user)
      if (allowedSet.size > 0) {
        const role = String(user.role || "").toLowerCase();
        if (!allowedSet.has(role)) throw new Error("Forbidden");
      }

      // 5) Optional: status gate (uncomment if you enforce 'active' only)
      // if (String(user.status || "").toLowerCase() !== "active") {
      //   throw new Error("Inactive");
      // }

      // All good — pass user data to the route if you like
      return { user, authed: true };
    } catch {
      // Any failure → go to Login (clear bad token if present)
      try {
        localStorage.removeItem("cm_at");
      } catch {
        // Intentionally ignored: auth fallback should continue without blocking the user flow.
      }
      throw redirect("/login");
    }
  };
